import { z } from 'zod';
// Create validation and DTO type
export const meetingBodyPositionCreateSchema = z.object({
    title: z
        .string('Title is required')
        .min(1, 'Title is required')
        .max(300, 'Title must be less than 300 characters'),
    description: z.string('Description is required').min(1, 'Description is required'),
});
// Update validation and DTO type
export const meetingBodyPositionUpdateSchema = meetingBodyPositionCreateSchema.extend({
    title: z
        .string('Title is required')
        .min(1, 'Title is required')
        .max(300, 'Title must be less than 300 characters')
        .optional(),
    description: z.string('Description is required').min(1, 'Description is required').optional(),
});
// Reorder validation and DTO type
export const meetingBodyPositionReorderSchema = z.object({
    meetingBodyPositionIds: z
        .array(z.number())
        .describe('List of position IDs where position in the array determines their display order. All positions must be provided in the desired order.'),
});
